<div
  [class]="containerClasses()"
  [style.background-color]="colorStyles().background"
  [style.border-color]="colorStyles().border"
  [style.color]="colorStyles().text"
  [attr.aria-label]="ariaLabel()"
  [attr.role]="ariaLabel() ? 'img' : null"
>
  <i [class]="iconClasses()" aria-hidden="true"></i>
</div>
